import { forwardRef, isValidElement } from "react";
import type { IconsaxComponent } from "../../../../../Iconsax/Iconsax.types.js";
import { ICONSAX_SIZE } from "../../../../../Iconsax/Iconsax.types.js";
import { Tooltip } from "../../../../../Tooltip/Tooltip.component.js";
import { useSidebar } from "../../../../Sidebar.context.js";
import { SidebarItemText, StyledSidebarItemBodyWrapper } from "./style.js";
import { SidebarItemBodyProps } from "./types.js";

export const SidebarItemBody = forwardRef<HTMLDivElement, SidebarItemBodyProps>(
    ({ label, badge, disabled, rightComponent, icon, animatedIconNode }, ref): JSX.Element => {
        const { transitionState, transitionDuration } = useSidebar();

        const renderIcon = () => {
            if (animatedIconNode) return animatedIconNode;
            if (isValidElement(icon)) return icon;
            if (icon) {
                const IconComponent = icon as IconsaxComponent;
                return <IconComponent size={ICONSAX_SIZE.LARGE} />;
            }
            return null;
        };

        const getComponent = () => {
            return (
                <StyledSidebarItemBodyWrapper
                    transitionDuration={transitionDuration}
                    collapsed={transitionState !== "entered"}
                    badge={badge}
                    ref={ref}
                >
                    {renderIcon()}
                    <SidebarItemText transitionState={transitionState} transitionDuration={transitionDuration}>
                        {label}
                    </SidebarItemText>
                    {rightComponent}
                </StyledSidebarItemBodyWrapper>
            );
        };

        return disabled && disabled.disabled ? (
            <Tooltip placement={["top"]} content={disabled.disabledTooltip}>
                {getComponent()}
            </Tooltip>
        ) : (
            <>{getComponent()}</>
        );
    },
);
